<template>
  <div ref="buttonNew" class="buttonNew">
    <div class="buttonNew__wrap">
      <font-awesome-icon
        v-click-outside="onClickOutside"
        class="buttonNew__icon"
        icon="fas fa-ellipsis-v"
        @click.stop="onOpen($event)"
      />
      <div v-if="showPopup" class="popup">
        <div>
          <font-awesome-icon
            class="icon icon__close"
            icon="fa-close"
            @click.stop="onClose($event)"
          />
          <span class="popup__title">Actions</span>
        </div>
        <div class="popup__options" @click="onClose($event)">
          <slot name="option" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { nextTick, ref } from 'vue'

const showPopup = ref(false)
const buttonNew = ref(null)

function onOpen(e) {
  showPopup.value = true
  nextTick(() => {
    let activeBtn = document.querySelector('.buttonNew--active')
    if (activeBtn) {
      activeBtn.classList.remove('buttonNew--active')
    }
    let popups = [...document.querySelectorAll('.popup--active')]
    if (popups.length > 0) {
      popups[0].classList.remove('popup--active')
    }
    let children = [...e.currentTarget.parentElement.children]
    children.forEach((child) => {
      let childExists = child.classList.contains('popup')
      if (childExists) {
        child.classList.add('popup--active')
        buttonNew.value.classList.add('buttonNew--active')
      }
    })
  })
}
function onClose(e) {
  nextTick(() => {
    const btn = buttonNew.value
    if (btn) {
      btn.classList.remove('buttonNew--active')
    }
    if (document.querySelector('.popup')) {
      document.querySelector('.popup').classList.remove('popup--active')
    }
    let exists = e.currentTarget
      .closest('.popup')
      .classList.contains('popup--active')
    if (exists) {
      e.currentTarget.closest('.popup').classList.remove('popup--active')
    }
  })
}
function onClickOutside() {
  showPopup.value = false
}
</script>
<style lang="scss">
.buttonNew {
  position: absolute;
  top: 10px;
  right: 10px;
  height: fit-content;
  width: fit-content;
  cursor: pointer;
  opacity: 1;
  z-index: 1;
  transition: opacity 100ms ease-in-out;
  will-change: opacity;
  &__wrap {
    position: relative;
  }
  &__icon {
    padding: 0.3rem 0.8rem;
    color: #aaafc1;
    transform: rotate(90deg);
    background: white;
    border: 1px solid #e6e9f0;
    height: 1.2rem;
    border-radius: var(--border-radius);
    &:hover {
      color: #454a5b;
      background: #e6e7ec;
    }
  }
  &--active {
    z-index: 2;
  }
}

.icon {
  color: #aaafc1;
  &__close {
    padding: 1px 6px;
    position: absolute;
    right: 5px;
    border-radius: 5px;
    &:hover {
      color: #454a5b;
      background: #e6e7ec;
    }
  }
}

.popup {
  position: absolute;
  display: none;
  top: 0;
  right: 0;
  background: white;
  width: max-content;
  min-width: 150px;
  max-width: 300px;
  transform: translateY(0px);
  box-shadow: 0px 2px 7px #15174a30;
  border: 1px solid #e6e9f0;
  padding: 5px;
  border-radius: 5px;
  &--active {
    display: block;
  }
  &__title {
    padding-left: 5px;
    text-transform: uppercase;
    color: #454a5b;
    font-size: 12px;
    display: block;
    padding-bottom: 5px;
  }
  &__options {
    display: flex;
    flex-direction: column;

    span {
      padding-left: 5px;
      &:hover {
        background: #f6f6f6;
      }
    }
  }
  &__option {
    padding-left: 5px;
    border-radius: 5px;
    display: block;
    width: 100%;
    color: #767c98;
    font-size: 14px;
    background: white;
    white-space: normal;
    &--red {
      color: #ff0a0a;
    }
    &:hover {
      background: #f6f6f6;
    }
  }
}

.grid-container--list-view {
  .popup {
    transform: translateY(0);
  }
}
</style>
